import { Navigate, useLocation } from "react-router-dom";

import MagicLinkLogin from "@/components/MagicLinkLogin";
import { useAuth } from "@/contexts/AuthContext";

export default function LoginPage() {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user) {
    const state = location.state as { from?: { pathname?: string } } | null;
    let redirectTo = state?.from?.pathname;

    if (!redirectTo) {
      redirectTo = user.subscription_status === "active" ? "/episodes" : "/paywall";
    }

    return <Navigate to={redirectTo} replace />;
  }

  return <MagicLinkLogin />;
}
